import { useCallback } from "react";

import { useExplorerGlobals } from "contexts/explorerGlobals";

/**
 * Returns handlers to redirect mouse events (mousedown, mousemove) to the canvas.
 * Used when pointer events hit an overlay (e.g. SVG markers) instead of the canvas,
 * so Novorender's ControllerInput can receive the events for navigation.
 */
export function useRedirectMouseEvents() {
    const {
        state: { canvas },
    } = useExplorerGlobals();

    const redirectMousedown = useCallback(
        (e: PointerEvent, button: number) => {
            if (!canvas) {
                return;
            }
            canvas.dispatchEvent(
                new MouseEvent("mousedown", {
                    clientX: e.clientX,
                    clientY: e.clientY,
                    button,
                    buttons: e.buttons,
                    bubbles: true,
                }),
            );
        },
        [canvas],
    );

    const redirectMousemove = useCallback(
        (e: PointerEvent) => {
            if (!canvas) {
                return;
            }
            canvas.dispatchEvent(
                new MouseEvent("mousemove", {
                    view: canvas.ownerDocument?.defaultView ?? window,
                    clientX: e.clientX,
                    clientY: e.clientY,
                    movementX: e.movementX,
                    movementY: e.movementY,
                    buttons: e.buttons,
                    bubbles: true,
                }),
            );
        },
        [canvas],
    );

    return { redirectMousedown, redirectMousemove };
}
